let GERAR_OS = 16;
let IMEDIATAR_OS = 18;
let CODIGOS_ESPECIAIS = 17;
let VALIDACAO_LIDER = 99;
let BAIXA_IMPRODUTIVA = 12;
let BAIXA_PRODUTIVA_MOVIMENTACAO = 11;
let BAIXA_PRODUTIVA = 10;
let GERAR_OS_REFAZER_DESOB = 13;
let FINISH_ACTIVITY = 20;
let MDU_MODERNIZACAO = 32;
let GERAR_OCORRENCIA = 22;

export { BAIXA_IMPRODUTIVA, BAIXA_PRODUTIVA, BAIXA_PRODUTIVA_MOVIMENTACAO, CODIGOS_ESPECIAIS, FINISH_ACTIVITY, GERAR_OS, GERAR_OS_REFAZER_DESOB, GERAR_OCORRENCIA, IMEDIATAR_OS, MDU_MODERNIZACAO, VALIDACAO_LIDER };

